import { render, staticRenderFns } from "./AdvStatic.vue?vue&type=template&id=9818e366&"
import script from "./AdvStatic.vue?vue&type=script&lang=js&"
export * from "./AdvStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports